module.exports = __webpack_public_path__ + "img/deck-appa-page-banner.8c6bae85.png";